var convert = require('./convert'),
    func = convert('compact', require('../compact'), require('./_falseOptions'));

func.placeholder = require('./placeholder');
module.exports = func;



//////////////////
// WEBPACK FOOTER
// ./~/lodash/fp/compact.js
// module id = 716
// module chunks = 0